var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ portrait: !!_vm.portraitUrl }},[_c('img',{attrs:{"fetchpriority":"low","loading":"lazy","src":_vm.portraitUrl ?? _setup.NO_PORTRAIT_URL,"alt":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }